import { useMutation } from '@tanstack/react-query'
import { AppBox, AppIcon, AppTypography, InfoBox, ParkHistoryLoader } from 'components'
import { ApiQueryKeys, InfoBoxSettingTypes } from 'globals/constants'
import { centsToDollar, getMDYFormattedDate } from 'globals/functions'
import { useSnackbar } from 'notistack'
import { FC, useEffect } from 'react'
import { UserPaymentsApi } from 'sdk'

interface Props {
  UserId: string
}

export const ProfileInvoicesHelpModule: FC<Props> = ({ UserId }) => {
  const userPaymentApi = new UserPaymentsApi()

  const { enqueueSnackbar } = useSnackbar()
  const {
    data: invoices,
    mutate: getInvoices,
    isPending: isGettingInvoices,
  } = useMutation({
    mutationKey: [ApiQueryKeys.payment.getInvoices],
    mutationFn: () => userPaymentApi.GetUserChargeHistory(UserId!),
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
  })
  useEffect(() => {
    getInvoices()
  }, [])
  return (
    <>
      <InfoBox dismissable={true} settingUniqueKey={InfoBoxSettingTypes.ProfileInvoiceHelpModuleDismissed}>
        This is the history of your Past Invoices with ParkSitesIO
      </InfoBox>
      <AppBox paddingTop={2}>
        {isGettingInvoices ? (
          <ParkHistoryLoader />
        ) : (
          <AppBox display={'flex'} flexDirection={'column'} gap={2}>
            {invoices?.map((invoice, index) => (
              <AppBox
                padding={2}
                backgroundColor="grey.50"
                borderRadius={3}
                border={1}
                borderColor={'grey.200'}
                key={index}
              >
                <AppBox
                  display={'flex'}
                  gap={3}
                  alignItems={'center'}
                  paddingBottom={1}
                  borderBottom={1}
                  borderColor={'grey.200'}
                >
                  <AppTypography fontWeight={500}>{getMDYFormattedDate(new Date(invoice.Created))}</AppTypography>
                  <AppBox
                    borderRadius={9}
                    display={'inline-table'}
                    paddingX={2}
                    paddingTop={0.3}
                    paddingBottom={0.5}
                    backgroundColor={invoice.Paid ? '#24D164' : 'red'}
                  >
                    <AppTypography component={'span'} color={'white'} fontWeight={500} fontSize={14}>
                      {invoice.Paid ? 'Paid' : 'UnPaid'}{' '}
                    </AppTypography>
                  </AppBox>
                  <AppBox width={'100%'} textAlign={'right'}>
                    <AppIcon
                      icon={'line-md:external-link'}
                      color="blue"
                      size="large"
                      onClick={() => window.open(invoice.InvoiceUrl, '_blank')}
                    />
                  </AppBox>
                </AppBox>
                <AppBox paddingTop={2}>
                  <AppTypography color={'grey.800'}>
                    Charge Type: {invoice.ChargeType === 'Sub_Account' ? 'Sub Account Purchase' : 'Subsciption'}
                  </AppTypography>
                  <AppTypography color={'grey.800'}>Invoice No: {invoice.InvoiceId}</AppTypography>
                  <AppTypography color={'grey.800'}>Charged Amount: {centsToDollar(invoice.Amount)}</AppTypography>
                  {invoice.CardLast4Digit && (
                    <AppTypography color={'grey.800'}>
                      Payment Method: {invoice.CardBrand?.toUpperCase()} XXXX-{invoice.CardLast4Digit}
                    </AppTypography>
                  )}
                </AppBox>
              </AppBox>
            ))}
          </AppBox>
        )}
      </AppBox>
    </>
  )
}
